import * as React from 'react';
import Tab from 'react-bootstrap/Tab';
import Nav from 'react-bootstrap/Nav';

import Button from './Button';


interface StepFormProps {
  children: any[]
  hideStepNumbers?: boolean
}

const StepForm = (
  props: StepFormProps
) => {
  // Filter out non-'Step' childs.
  const stepChildren = React.Children.map(props.children, child => {
    if (child?.type?.name === Step.name) { return child }
  })

  // Construct an array with indices of child that are not disabled.
  const activeChildren = stepChildren
    .map((child: any, i: number) => !child.props.disabled ? i : undefined)
    .filter((x: any) => x !== undefined)
  
  const findStepIndex = (step: number) => activeChildren.findIndex((c: any) => c === step);

  const [activeStep, setActiveStep] = React.useState(activeChildren[0] || 0);
  const nextStep = stepChildren[activeChildren[findStepIndex(activeStep) + 1]];
  const prevStep = stepChildren[activeChildren[findStepIndex(activeStep) - 1]];
  
  const next = () => setActiveStep(activeChildren[findStepIndex(activeStep) + 1]);
  const prev = () => setActiveStep(activeChildren[findStepIndex(activeStep) - 1]);
  const setActiveStepNav = ( eventKey: string ) => setActiveStep(parseInt(eventKey, 10));

  return (
      <Tab.Container activeKey={activeStep}>
        <div>
          <Nav
            className='flex-column flex-md-row mb-4 mx-0 nav-fill nav-tabs nav-tabs-sm'
            onSelect={setActiveStepNav as any}
          >
            {stepChildren.map((child: any, i: number) => (
              <Nav.Item key={`NavItem_${i}`}>
                <Nav.Link eventKey={i} disabled={child.props.disabled}>
                  {!props.hideStepNumbers && `${i + 1}. `}
                  {child.props.name}
                </Nav.Link>
              </Nav.Item>
            ))}
          </Nav>
        </div>

        <Tab.Content>
          {stepChildren.map((child: any, i: number) => (
            <Tab.Pane key={`TabPane_${i}`} eventKey={i}>
              {child}
            </Tab.Pane>
          ))}
        </Tab.Content>

        <div className="d-flex mt-4">
          {(activeStep !== 0 && prevStep) && (
            <Button
              variant="link"
              onClick={prev}
            >
              <i className="modus-icons left-icon">arrow_left</i> 
              {prevStep.props.name ? prevStep.props.name : "Back"}
            </Button>
          )}
          {(activeStep !== (activeChildren.length - 1) && nextStep) && (
            <Button
              variant="primary"
              className="ml-auto"
              onClick={next}
            >
              {nextStep.props.name ? nextStep.props.name : "Next"}
              <i className="modus-icons right-icon">arrow_right</i> 
            </Button>
          )}
        </div>
      </Tab.Container>
  );
}

interface StepProps {
  children: any
  name?: string
  disabled?: boolean
}

export const Step = (
  props: StepProps
) => {
  return (
    <React.Fragment>
      {props.children}
    </React.Fragment>
  );
}

export default StepForm;
